"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var json_1 = require("./json");

var AppParamsHelper_1 = require("../helpers/AppParamsHelper");

var get_1 = require("./get");

function getOrchestratedDataset(element) {
  var response = {};

  if (element) {
    var _a = element.dataset,
        dataset = _a === void 0 ? {} : _a;

    for (var _i = 0, _b = Object.entries(dataset); _i < _b.length; _i++) {
      var _c = _b[_i],
          key = _c[0],
          rawValue = _c[1];
      var tryParseResponse = json_1.jsonTryParse(rawValue);
      var value = tryParseResponse.value;

      if (typeof value === 'string') {
        var regex = /^\{(global)\:(.*)\}$/;
        var match = regex.exec(value);

        if (match && match.length > 2) {
          var location_1 = match[1],
              path = match[2];

          if (location_1 === 'global') {
            if (window[AppParamsHelper_1.KSYS_GLOBAL_VARIABLES_WINDOW_KEY]) {
              value = get_1.get(window[AppParamsHelper_1.KSYS_GLOBAL_VARIABLES_WINDOW_KEY], path);
            }
          }
        }
      }

      response[key] = value;
    }
  }

  return response;
}

exports.getOrchestratedDataset = getOrchestratedDataset;